export const spending = [
  { value: "foodExpenses ", label: "食費" },
  { value: "necessary", label: "日用品" },
  { value: "clothes", label: "衣服" },
  { value: "beauty ", label: "美容" },
  { value: "communicationFee ", label: "交際費" },
  { value: "medicalBills", label: "医療費" },
  { value: "educationFee ", label: "教育費" },
  { value: "utilityCosts", label: "光熱費" },
  { value: "transportation ", label: "交通費" },
  { value: "communicationCosts ", label: "通信費" },
  { value: "housingExpenses ", label: "住居費" },
  { value: "other", label: "その他" },
];

export const income = [
  { value: "salary ", label: "給料" },
  { value: "pocketMoney ", label: "お小遣い" },
  { value: "bonus ", label: "賞与" },
  { value: "sideline", label: "副業" },
  { value: "investment ", label: "投資" },
  { value: "extraordinaryIncome ", label: "臨時収入" },
  { value: "other", label: "その他" },
];
